import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';

    interface Props {
        className?: HTMLAttributes['class'];
    }

    
export default /*@__PURE__*/_defineComponent({
  ...{
        inheritAttrs: false,
    },
  __name: 'Chat',
  props: {
    className: {}
  },
  setup(__props: any) {

    

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass(_ctx.className)
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.02358 0.746094C7.90739 0.746094 6.80214 0.965943 5.77092 1.39309C4.73969 1.82024 3.8027 2.44631 3.01344 3.23558C1.41945 4.82956 0.523957 6.99148 0.523957 9.24572C0.516527 11.2084 1.1961 13.1118 2.44487 14.626L0.744948 16.3259C0.627009 16.4454 0.547116 16.5972 0.515349 16.7621C0.483582 16.927 0.501366 17.0976 0.566455 17.2524C0.637051 17.4053 0.751496 17.5338 0.895261 17.6216C1.03903 17.7094 1.20563 17.7524 1.37392 17.7453H9.02358C11.2778 17.7453 13.4397 16.8498 15.0337 15.2559C16.6277 13.6619 17.5232 11.5 17.5232 9.24572C17.5232 6.99148 16.6277 4.82956 15.0337 3.23558C13.4397 1.64159 11.2778 0.746094 9.02358 0.746094ZM9.02358 16.0454H3.42233L4.21279 15.255C4.3711 15.0957 4.45996 14.8803 4.45996 14.6557C4.45996 14.4312 4.3711 14.2158 4.21279 14.0565C3.09984 12.9448 2.40677 11.4816 2.25167 9.91616C2.09656 8.35075 2.48902 6.77998 3.36217 5.47148C4.23533 4.16298 5.53516 3.19769 7.04021 2.74008C8.54526 2.28248 10.1624 2.36086 11.6161 2.96187C13.0699 3.56289 14.2703 4.64935 15.0128 6.03617C15.7553 7.42298 15.994 9.02434 15.6882 10.5674C15.3825 12.1105 14.5511 13.4998 13.3359 14.4987C12.1206 15.4976 10.5967 16.0442 9.02358 16.0454Z",
      fill: "currentColor"
    }, null, -1)
  ]), 2))
}
}

})